export default __webpack_public_path__ + "static/media/man-with-talking-points.61efa1d6.svg";